import { ProfileSkills } from '@seek/profile-read-ui';
import { useTranslations } from '@vocab/react';
import { Stack } from 'braid-design-system';
import React, { useMemo } from 'react';

import { Card } from 'src/components/Card/Card';
import { CardAction } from 'src/components/Card/CardAction/CardAction';
import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';
import { SKILLS } from 'src/components/Router';
import { EDIT } from 'src/consts';
import { SKILLS_FORM } from 'src/reducers/forms';

import { EditSkills } from '../EditSkills/EditSkills';
import { useSkills, useSuggestedSkills } from '../data';

import translations from './.vocab';

export const ReadSkills = () => {
  const { t } = useTranslations(translations);
  const { loading, error, skills } = useSkills();

  useSuggestedSkills();

  const skillsText = skills.map((skill) => skill.keyword.text);
  const actionText = t('Add skills');

  const isEmpty = skills.length === 0;

  const title = isEmpty ? t('Add skills') : t('Edit skills');

  const cardAction = useMemo(
    () => (
      <CardAction
        to={SKILLS}
        mode={EDIT}
        actionText={actionText}
        data={{ automation: 'skills-edit-link' }}
        isEmpty={isEmpty}
        analytics={{
          currentPageSectionState: isEmpty ? 'add' : 'edit',
        }}
      />
    ),
    [actionText, isEmpty],
  );
  const isLoading = Boolean(loading || error);

  return (
    <>
      <Card
        name={SKILLS}
        title={t('Skills')}
        emptyCardText={t('Let employers know how valuable you can be to them.')}
        isEmpty={isEmpty}
        cardAction={cardAction}
        loading={isLoading}
        loader={<LoadingItem type="text" size="standard" width="medium" />}
      >
        <Stack space="large">
          {skills.length > 0 ? <ProfileSkills skills={skillsText} /> : null}
        </Stack>
      </Card>
      <FormDrawer
        title={title}
        description={t(
          'Help employers find you by showcasing all of your skills.',
        )}
        component={EditSkills}
        card={SKILLS}
        formName={SKILLS_FORM}
      />
    </>
  );
};
